module.exports = __webpack_public_path__ + "static/c1-77906113116f8345f7f0418db1930c53.png";